<template>
    <div class="vote_info">
        <div class="info_list">
            <el-card>
                <el-form inline size="small" :model="queryFiles" label-width="100px">
                    <el-form-item label="作品编号">
                        <el-input clearable v-model="queryFiles.worksNumber" placeholder="输入序号"></el-input>
                    </el-form-item>
                    <el-form-item label="作品类别">
                        <el-select v-model="queryFiles.voteType" filterable placeholder="请选择" clearable>
                        <el-option
                            v-for="item in voteTypes"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="作品组别">
                        <el-select v-model="queryFiles.voteGrouping" filterable placeholder="请选择" clearable>
                        <el-option
                            v-for="item in voteGroupings"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="身份">
                        <el-select v-model="queryFiles.part" filterable placeholder="请选择" clearable>
                        <el-option
                            v-for="item in parts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="作者">
                        <el-input clearable v-model="queryFiles.authorName" placeholder="输入作者"></el-input>
                    </el-form-item>
                    <el-form-item label="单位">
                        <el-input clearable v-model="queryFiles.authorUnit" placeholder="输入单位"></el-input>
                    </el-form-item>
                    <el-form-item label="作者类别">
                        <el-select v-model="queryFiles.authorType" filterable placeholder="请选择" clearable>
                        <el-option
                            v-for="item in authorTypes"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="淘汰开始时间" prop="disuseDate">
                        <el-date-picker
                            v-model="queryFiles.disuseDate"
                            type="datetime"
                            format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期"
                            style="width: 190px;"
                        >
                        </el-date-picker>
                    </el-form-item> -->
                </el-form>
                <el-button style="margin-left: 100px" type="primary" @click="getCancelVoteList">查询</el-button>
                <el-button style="margin-left: 20px" type="danger" @click="resetBtn">重置</el-button>
                <el-button style="margin-left:20px" type="primary" @click="downloadBtn">下载</el-button>
                <el-button style="margin-left: 20px" type="primary" @click="goBack">返回</el-button>
            </el-card>
            <el-card>
                <el-table :data="cancelVoteList"
                    :header-cell-style="getRowClass"
                    border
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    style="width: 100%; flex: auto; overflow-y: scroll" tooltip-effect="light">
                    <el-table-column type="selection" width="55" align="center"></el-table-column>
                    <el-table-column align="center" label="作品编号" prop="works_number" fixed></el-table-column>
                      <el-table-column label="作品" align="center">
                        <template slot-scope="{row}">
                            <el-image v-if="row.vote_type===1"
                            :src="row.img_url"
                            :preview-src-list="[row.img_url]"
                            style="width: 65px; height: 65px;"
                            ></el-image>
                            <img v-else :src="row.cover_img" @click="viewVideoBtn(row)" style="width: 65px; height: 65px;cursor: pointer;" />
                            <!-- <video v-else :src="row.img_url" @click="viewVideoBtn(row)" style="width: 65px; height: 65px;cursor: pointer;"></video> -->
                        </template>
                    </el-table-column>
                    <el-table-column v-for="(item,idx) in CancelVoteListField" :key="idx" v-bind="item"></el-table-column>
                    <el-table-column label="操作" fixed="right" align="center" width="240">
                        <template slot-scope="{ row }">
                            <el-button
                                size="small"
                                type="primary"
                                @click="cancelPassBtn(row)"
                            >取消淘汰</el-button>
                            
                            <el-button
                                size="small"
                                type="danger"
                                @click="deleteVote(row)"
                            >删除</el-button>

                            <el-dropdown trigger="click" style="margin-left: 10px;">
                            <el-button  size="small" type="success">授权</el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="viewAuthorizeImg(row)">查看</el-dropdown-item>
                                <el-dropdown-item @click.native="downAuthorizeImg(row)">下载</el-dropdown-item>
                            </el-dropdown-menu>
                            </el-dropdown>

                        </template>
                    </el-table-column>
                </el-table>
                <el-row>
                    <el-pagination
                        style="display: flex;justify-content: center;margin-top: 20px"
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageNum"
                        :page-sizes="[20, 30, 40, 50]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalElements">
                    </el-pagination>
                </el-row>
            </el-card>
        </div>
         <!-- 删除弹出框 -->
         <a-modal :visible="delOpen" ok-text="确认" width="320px" cancel-text="取消" @ok="handleOk" @cancel="handleCancel">
            <p>确定要删除吗？</p>
        </a-modal>

        <!--查看图片-->
        <el-dialog :visible.sync="imgDialogState" :append-to-body="true" width="70%" @close="imgDialogCancel">
            <el-image
                class="img-style"
                :src="imgUrl"
                fit="contain"
                :preview-teleported="true"
            />
        </el-dialog>

         <!--查看视频-->
         <el-dialog :visible.sync="videoDialogState" :append-to-body="true" width="70%" @close="videoDialogCancel">
            <video-player class="video-player vjs-custom-skin carousel-video"
                    ref="videoPlayer"
                    :playsinline="true"
                    :options="playerOptions">
            </video-player>
        </el-dialog>

         <!--查看授权书-->
          <el-dialog 
            title="授权书" 
            class="dialog_style" 
            :visible.sync="showAuthorizeImg" 
            :append-to-body="true" width="50%"
             @close="authorizeImgCancel">
            <el-image
                style="height: 100%;max-height: 110vh;  width:100%;"
                :src="authorizeImg"
                fit="contain"
                :preview-teleported="true"
            />
        </el-dialog>
    </div>
</template>
<script>
import JSZip from "jszip"
import { saveAs } from 'file-saver';
export default{
    data(){
        return{
            showAuthorizeImg:false,
            authorizeImg:'',
            bindBtnStyle: {
                type: "primary",
                size: "small",
                round: true
            },
            queryFiles: {
                worksNumber: "", //作品序号
                voteType: "", //详情类型 1图片 2视频
                voteGrouping: "", //作品组别1中小学 2高校
                part:"",//身份
                authorName: "", //作者姓名
                authorUnit: "", //作者单位
                authorType: "", //作者类别 1个人 2团队
                //disuseDate:"" //淘汰时间
            },
            //详情类型
            voteTypes: [{
                    id: "1",
                    name: "图片"
                },{
                    id: "2",
                    name: "视频"
                },{
                    id:"3",
                    name:"AI视频"
                }
            ],
            //作品组别 
            voteGroupings:[{
                id: "1",
                name: "中小学",
                },{
                id: "2",
                name: "高校",
                }
            ],
            //身份 
            parts:[{
                id: "1",
                name: "学生",
                },{
                id: "2",
                name: "教师",
                }
            ],
            //作者类别
            authorTypes:[{
                id: "1",
                name: "个人",
                },{
                id: "2",
                name: "团队",
                }
            ],
            CancelVoteListField: [{
                    label: "报名时间",
                    prop: "enroll_date",
                    width:"160"
                },{
                    label: "排名",
                    prop: "ranking"
                },{
                    label: "当前票数",
                    prop: "vote_number",
                },{
                    label: "作品类型",
                    prop: "vote_type",
                    formatter(row, column,val) {
                        return val===1 ?"图片":val==2?"视频":"AI视频";
                    }
                },{
                    label: "作品组别",
                    prop: "vote_grouping",
                    formatter(row, column,val) {
                        return val==1 ?"中小学":"高校";
                    }
                },{
                    label: "身份",
                    prop: "part",
                    formatter(row, column,val) {
                        return val==1 ?"学生":"教师";
                    }
                },{
                    label: "作品名称",
                    prop: "works_name",
                    width:"150"
                },{
                    label: "作者",
                    prop: "author_name",
                },{
                    label: "单位",
                    prop: "author_unit",
                },{
                    label: "电话",
                    prop: "phone",
                    width:"120"
                },{
                    label: "作品简介",
                    prop: "introduce",
                },{
                    label: "作者类别",
                    prop: "author_type",
                    formatter(row, column,val) {
                        return val == 1 ? "个人" : val == 2 ? "团队" : "单位";
                    }
                },{
                    label: "状态",
                    prop: "works_type",
                    formatter(row, column,val) {
                        return val == 1 ? "淘汰" : val == 2 ? "晋级" : "初始";
                    }
                },{
                    label: "淘汰时间",
                    prop: "disuse_date",
                }
            ].map(item => ({
                ...item,
                align: "center",
                "header-align": "center",
                "show-overflow-tooltip": true
            })),
            pageNum: 1, //初始页
            pageSize: 20, //每页的个数
            totalElements:0,//数据总数
            cancelVoteList:[],
            delOpen: false, //删除弹框
            delId: "", //删除id
            imgDialogState:false,
            videoDialogState:false,
            modaltitle:'',
            playerOptions: {
                //播放速度
                playbackRates: [0.5, 1.0, 1.5, 2.0],
                //如果true,浏览器准备好时开始回放。
                autoplay: false,
                // 默认情况下将会消除任何音频。
                muted: false,
                // 导致视频一结束就重新开始。
                loop: false,
                // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                preload: 'auto',
                language: 'zh-CN',
                // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                aspectRatio: '16:9',
                // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                fluid: true,
                sources: [{
                    //类型
                    type: "video/mp4",
                    //url地址
                    src: ''
                }],
                //你的封面地址
                poster: '',
                //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                notSupportedMessage: '此视频暂无法播放，请稍后再试',
                controlBar: {
                timeDivider: true,
                durationDisplay: true,
                remainingTimeDisplay: false,
                //全屏按钮
                fullscreenToggle: true
                }
            },
            multipleSelection:[],
            voteType:'',
            imgUrl:''
        }
    },
    created() {
        this.$nextTick(() => {
            this.getCancelVoteList();
        });
    },
    methods:{
         handleSelectionChange(val) {
            this.multipleSelection = val
        },
        //下载
        downloadBtn(){
            const selectDate=this.multipleSelection;
            if (selectDate.length == 1) { //单张下载
                //console.log('sss'+selectDate[0].img_url)
                const imageUrl = selectDate[0].img_url;
                let suffix=this.getFilefType(imageUrl);
                const xhr = new XMLHttpRequest();
                xhr.open("GET", imageUrl, true);
                xhr.responseType = "blob";
                xhr.onload = function () {
                    if (xhr.status === 200) {
                        const url = window.URL.createObjectURL(xhr.response);
                        const link = document.createElement("a");
                        link.href = url;
                        //link.setAttribute("download", "image.png");
                        link.setAttribute("download", (selectDate[0].works_name || selectDate[0].works_number)+'.'+suffix);
                        document.body.appendChild(link);
                        link.click();
                    } else {
                        console.error("图片下载失败");
                    }
                };
                xhr.send();
            }else{  //批量下载
            this.createAndDownloadImageZip(selectDate);
            }
        },
        createAndDownloadImageZip(selectDate) {
            const zip = new JSZip();
            for (let i = 0; i < selectDate.length; i++) {
                // 获取图片资源
                fetch(selectDate[i].img_url).then(response => response.blob()).then(blob => {
                    let suffix=this.getFilefType(selectDate[i].img_url)
                    // 将Blob添加到ZIP包中，这里假设图片名为'image'+i+'.jpg'
                    zip.file(`${selectDate[i].works_name}_${i}.${suffix}`, blob);
                    // 在所有图片都处理完之后生成ZIP
                    if (i === selectDate.length - 1) {
                        zip.generateAsync({ type: 'blob' }).then(content => {
                            // 下载ZIP文件
                            saveAs(content, 'download.zip');
                        });
                    }
                });
                
            }
        }, 
        // 获取文件后缀名
        getFilefType(url) {
            let startIndex = url.lastIndexOf(".");
            if (startIndex !== -1) {
                return url.slice(startIndex + 1).toLowerCase();
            } else {
                return "";
            }
        },
        goBack(){
            this.$router.push("/eduVoteList");
        },
        //头部样式
        getRowClass({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return "background-color: #f5f7fa;color:#000;width:100%;text-aligin:center;text-align: center;";
            } else {
                return "";
            }   
        },
        getCancelVoteList(){
            this.postAxios("/secureVote/selectAllSecureVote", {
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                parameterMap:{
                    worksType:1,
                    ...this.queryFiles
                }
            }).then((res) => {
                if (res.success) {
                    this.cancelVoteList = res.content;
                    this.totalElements = res.totalCount;
                } else {
                    this.$message.error(res.message);
                    this.$router.push("/");
                }
            });   
        },
        //分页
        handleCurrentChange: function (currentPage) {
            this.pageNum = currentPage;
            this.getCancelVoteList();
        },
        handleSizeChange: function (size) {
            this.pageSize = size;
            this.getCancelVoteList();
        },
        //重置页面
        resetBtn() {
            this.pageNum = 1;
            this.pageSize = 20;
            this.queryFiles={};
            this.getCancelVoteList();
        },
        //查看图片和视频
        viewVideoBtn(row){
            if(row.vote_type===1){
                this.voteType=row.vote_type;
                this.imgUrl=row.img_url;
                this.imgDialogState=true;
            }else{
                this.playerOptions.poster = row.cover_img;
                this.playerOptions.sources[0].src = row.img_url;
                this.videoDialogState=true
            }
            
        },
        imgDialogCancel(){
            this.imgDialogState=false;
        },
        videoDialogCancel(){
            if(this.$refs.videoPlayer){
                this.$refs.videoPlayer.player.pause();
            }
            this.videoDialogState=false;
        },
        //取消淘汰
        cancelPassBtn(row){
            this.postAxios("/secureVote/updSecureVoteById", {
                id: row.id,
                worksType:0 //作品状态 0初始 1淘汰 2晋级
            }).then(res => {
                if (res.success == true) {
                    this.$message.success("已取消淘汰！");
                    this.getCancelVoteList();
                    //this.$router.push("/eduVoteList"); //作品列表
                } else if (res.success == false) {
                    this.$message.error(res.message);
                } else if (!res.success && res.statusCode == "401") {
                    this.$message.error(res.message);
                    this.$router.push("/");
                }
            });
        },
            //删除
        deleteVote(row){
            this.delId=row.id;
            this.delOpen=true;
        },
        //确认删除
        handleOk(){
            this.postAxios("/secureVote/delSecureVoteById", {
                id: this.delId
            }).then(res => {
                if (res.success == true) {
                    this.$message.success("删除成功！");
                    this.delOpen = false;
                    this.getCancelVoteList(); //列表
                } else if (res.success == false) {
                    this.$message.error(res.message);
                } else if (!res.success && res.statusCode == "401") {
                    this.$message.error(res.message);
                    this.$router.push("/");
                }
            });
        },
        //取消删除弹框
        handleCancel() {
            this.delOpen = false;
        },
        viewAuthorizeImg(row){
            this.authorizeImg=row.authorize_img;
            this.showAuthorizeImg=true;
        },
        authorizeImgCancel(){
            this.showAuthorizeImg=false;
        },
        downAuthorizeImg(row){
            //console.log('数据1'+row)
            const imageUrl = row.authorize_img;
            let suffix=this.getFilefType(imageUrl);
            const xhr = new XMLHttpRequest();
            xhr.open("GET", imageUrl, true);
            xhr.responseType = "blob";
            xhr.onload = function () {
                if (xhr.status === 200) {
                    const url = window.URL.createObjectURL(xhr.response);
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download",'授权书.'+suffix);
                    document.body.appendChild(link);
                    link.click();
                } else {
                    console.error("图片下载失败");
                }
            };
            xhr.send(); 
        }
    }
}
</script>
<style scoped lang="less">
.vote_info{
    width: 100%;
    height: 100%;
    .info_list{
        width: 95%;
        height: 100%;
        margin: 20px auto;
        .el-card {
        width: 100%;
        height: auto;
        margin-top: 15px;
        }
    }
    .img-style,.carousel-video{
        height: auto;
        width: 100%;
        margin: 0 auto;
    }
}
/deep/ .el-table .cell{
    padding: 0;
}
/deep/ .el-table .cell, .el-table--border td:first-child .cell, .el-table--border th:first-child .cell{
    padding: 0;
}
/deep/ .el-table--border th:first-child .cell, .el-table--border td:first-child .cell{
    padding: 0;
}
.dialog_style /deep/.el-dialog__body{
    padding: 5px 20px 20px;
}
</style>